module.exports = __webpack_public_path__ + "static/img/question4-9.33fb6b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/question4-9.png
// module id = hQ7z
// module chunks = 1